module.exports = __webpack_public_path__ + "media/mypage/images/icon-close-window-befae58bbec9f894cd31db739fe8cfcd.png";